import {FixFlickity} from "//www.okr.fr/cdn/shop/t/10/assets/helpers.js?v=55600738155002914361784882022";
import Delegate from "//www.okr.fr/cdn/shop/t/10/assets/ftdomdelegate.min.js?v=85864865866317895671761843817";
import {ToggleElem} from "//www.okr.fr/cdn/shop/t/10/assets/helpers.js?v=55600738155002914361784882022";

export class SectionTabs extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this._attachListeners();
  }

  _attachListeners() {
    this.allTabs.forEach(tab => {
      tab.addEventListener('click', this._switchTab.bind(this));
    });

    // Popup tables
    this.delegateElement.on('click', '[data-action="toggle-tables"]', this._toggleTables.bind(this));

    // Fix flickity loading after this JS
    setTimeout(() => {
      this._initSliders();
    }, 0);
  }

  _toggleTables (e, target){

    if (e) e.preventDefault();
    ToggleElem.toggleElement(e,target,'overlay');
  }

  get allTabs() {
    return this.querySelectorAll('.section-tabs__tab');
  }

  get allPanels() {
    return this.querySelectorAll('.section-tabs__panel');
  }

  get backgroundText() {
    return this.querySelector('.tabs-header__tabs-container .text-background');
  }
  
  _switchTab(event) {
    const targetPanel = event.target.getAttribute('data-tab');

    this.allTabs.forEach(tab => {
      if (targetPanel) {
        tab.classList.remove('active');
      }
    });

    event.target.classList.add('active');

    // Fake animation for background text
    this.backgroundText.style.opacity = 0;

    setTimeout(() => {
      this.backgroundText.innerHTML = event.target.innerHTML;
      this.backgroundText.style.opacity = 0.05;
    }, 200);

    // Center the active tab
    this._scrollToTab(event.target);

    // Switch to target panel
    if (targetPanel) {
      this._switchPanel(targetPanel);
    }
  }

  _scrollToTab(tab) {
    const wrapper = tab.closest('.tabs-header__wrapper');
    const tabRect = tab.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
  
    const offset = tabRect.left - wrapperRect.left + wrapper.scrollLeft;
    const centeredPosition = offset - (wrapperRect.width - tabRect.width) / 2;
  
    wrapper.scrollTo({
      left: centeredPosition,
      behavior: 'smooth'
    });
  }  

  _switchPanel(targetPanel) {
    this.allPanels.forEach(panel => {
      panel.classList.remove('active');
    });

    this.querySelector(`[data-panel="${targetPanel}"]`).classList.add('active');
  }

  _initSliders() {
    const sliders = this.querySelectorAll('.carousel');

    sliders.forEach(slider => {
      /*new Flickity(slider, {
        watchCSS: true
      });
       */
    });
  }
}

if (!customElements.get('section-tabs')) {
  customElements.define('section-tabs', SectionTabs);
}